import type { PodcastGenre } from '../models/podcast-genres.js';
import type { User } from '../models/user.model.js';
import type { FuuzeQueryKey } from './shared.js';

export const queryKeys = {
  user: {
    signIn: () => ['userSignIn', { type: 'user' }] as FuuzeQueryKey,
    checkPseudoAvailability: (pseudo: string) =>
      ['userCheckPseudoAvailability', { type: 'noType' }, pseudo] as FuuzeQueryKey,
    listLibraryAlreadyStartedEpisodes: (user?: User) =>
      ['listLibraryAlreadyStartedEpisodes', { type: 'podcastEpisode' }, user?.subscribedChannels] as FuuzeQueryKey,
    listLibraryNonStartedEpisodes: (user?: User) =>
      ['listLibraryNonStartedEpisodes', { type: 'podcastEpisode' }, user?.subscribedChannels] as FuuzeQueryKey,
  },
  podcast: {
    channelBySlug: (slug?: string) => ['podcastBySlug', { type: 'podcastChannel' }, slug] as FuuzeQueryKey,
    episodes: (channelId?: string) => ['podcastEpisodes', { type: 'podcastEpisode' }, channelId] as FuuzeQueryKey,
    episode: (itemId?: string, channelSlug?: string, slug?: string) =>
      ['podcastEpisode', { type: 'podcastEpisode' }, itemId, channelSlug, slug] as FuuzeQueryKey,
    episodeById: (episodeId?: string) => ['podcastEpisodeById', { type: 'podcastEpisode' }, episodeId] as FuuzeQueryKey,
    feedInfo: (feedUrl?: string) => ['podcastFeedInfo', { type: 'podcastChannel' }, feedUrl] as FuuzeQueryKey,
    streamUrl: (channelId?: string, itemId?: string) =>
      ['podcastStreamUrl', { type: 'noType' }, channelId, itemId] as FuuzeQueryKey,
    list: (channels?: string[]) => ['podcastList', { type: 'podcastChannel' }, channels] as FuuzeQueryKey,
    retrieveSlugById: (id?: string) => ['retrievePodcastSlugById', { type: 'noType' }, id] as FuuzeQueryKey,
    listTopPodcasts: (params?: { genre?: PodcastGenre; limit?: number }) =>
      ['listTopCharts', { type: 'podcastEpisode' }, params] as FuuzeQueryKey,
  },
  comments: {
    list: (itemId?: string) => ['comments', { type: 'comment' }, itemId] as FuuzeQueryKey,
    replies: (commentId: string) => ['commentReplies', { type: 'comment' }, commentId] as FuuzeQueryKey,
  },
  config: {
    retrieve: () => ['config', { type: 'config' }] as FuuzeQueryKey,
    listCountries: () => ['countries', { type: 'noType' }] as FuuzeQueryKey,
  },
  spotlight: {
    list: (itemId?: string) => ['spotlights', { type: 'spotlight' }, itemId] as FuuzeQueryKey,
    preview: (url?: string) => ['spotlight-preview', { type: 'noType' }, url] as FuuzeQueryKey,
    retrieve: (urlOrId?: string) => ['spotlight-retrieve', { type: 'spotlight' }, urlOrId] as FuuzeQueryKey,
  },
  creator: {
    checkSlugAvailability: (slug?: string) => ['slugAvailability', { type: 'noType' }, slug] as FuuzeQueryKey,
  },
  search: {
    search: (search?: string) => ['search', { type: 'noType' }, search] as FuuzeQueryKey,
  },
  stripe: {
    checkoutSession: (sessionId?: string | null, paymentIntent?: string | null) =>
      ['stripe/checkout-session', { type: 'noType' }, sessionId, paymentIntent] as FuuzeQueryKey,
    listPaymentIntents: (customerId: string) =>
      ['stripe-list-payment-intents', { type: 'noType' }, customerId] as FuuzeQueryKey,
    balance: (stripeAccountId?: string) =>
      ['stripe-retrieve-balance', { type: 'noType' }, stripeAccountId] as FuuzeQueryKey,
    listTransfers: (stripeAccountId?: string) =>
      ['stripe-list-transfers', { type: 'noType' }, stripeAccountId] as FuuzeQueryKey,
  },
  cloudflare: {
    verifyTurnstileToken: (token?: string) => ['verifyTurnstileToken', { type: 'noType' }, token] as FuuzeQueryKey,
  },
};
